import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { useBusinessHoursCheck } from '../../hooks/common';

/**
 * Banner de aviso para administradores que não configuraram horários de funcionamento
 */
export const BusinessHoursRequiredBanner: React.FC = () => {
  const { needsBusinessHours } = useBusinessHoursCheck();
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    navigate('/settings');
  };

  if (!needsBusinessHours) {
    return null;
  }

  return (
    <div
      className="antialiased"
      style={{
        backgroundColor: 'var(--color-secondary)',
        color: 'var(--color-on-secondary)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 items-start gap-3 sm:items-center">
            <ClockIcon className="h-6 w-6 flex-shrink-0" />
            <div className="min-w-0">
              <p className="font-semibold text-sm sm:text-base">
                Horários de Funcionamento Não Configurados
              </p>
              <p className="text-xs sm:text-sm opacity-90 mt-1">
                Configure os horários do seu estabelecimento para melhor organização
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={handleGoToSettings}
            className="w-full flex-shrink-0 px-4 py-2 rounded-lg font-medium text-sm hover:opacity-90 transition-opacity sm:w-auto"
            style={{
              backgroundColor: 'var(--color-primary)',
              color: 'var(--color-on-primary)',
            }}
          >
            Configurar Agora
          </button>
        </div>
      </div>
    </div>
  );
};
